import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
//import jsPDF from "jspdf";

//Services
import * as Service from "../../../services/Service.js";
import Constants from "../../../services/Constants.js";
import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

import {
  KeyboardTimePicker,
} from "components/pickers";

//import ReactExport from "react-data-export";

import { useTranslation } from "react-i18next";

//import XLSX from "xlsx";
//import FileSaver from "file-saver";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import * as api from "../../../actions/api.js";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, ViewList, preview, Edit } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { cellFocusEditor } from "../../../services/Common.js";

import { fr, enGB } from "date-fns/locale"; // import French and English locale
import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
import {
  getFacilityListByGroup,
  getNationalMOSRangeListByGroup,
} from "../../../services/Common.js";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const Products = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const FacilityId = localStorage.getItem("FacilityId");
  console.log("FacilityId: ", FacilityId);
  const FacilityName = localStorage.getItem("FacilityName");
  const menukey = "stock-status";
  const UserInfo = encryptionService.decryptUserInfo();
  const userId = UserInfo == 0 ? "" : UserInfo[0].id;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const DefaultFacilityId = localStorage.getItem("DefaultFacilityId");
  console.log("DefaultFacilityId: ", DefaultFacilityId);

  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(
    assignedProdGroupList.length
  );
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];
  /* const RoleItemGroupId = UserInfo == 0 ? "" : UserInfo[0].ItemGroupId; */

  // const MosTypelist = JSON.parse(localStorage.getItem("MosTypelist"));

  const classes = useStyles();
  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [productsData, selectProductsData] = useState([]);
  const [productsAllData, selectProductsAllData] = useState([]);
  const [productGroupData, selectProductGroupData] = useState([]);
  const [productGroupFilter, selectProductGroupFilter] = useState("0");
  const [firstLoad, setFirstLoad] = useState(true);
  const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [query, setQuery] = useState("");

  const [TableDataUpdate, setTableDataUpdate] = useState([]);
  const [ManyJsonSave, setInputChange] = useState({});
  const [radioValue, setRadioValue] = useState(2);
  const [isStockAvailable, setIsStockAvailable] = useState(0);
  const [dataItems, setDataItems] = useState([]);

  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  //const [currProductGroupId, setCurrProductGroupId] = useState(ProductGroupList[0].id);
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);


  const [FacilityList, setFacilityList] = useState(
    getSobapsWH(getFacilityListByGroup(RoleItemGroupId))
  );
  const isFacilityIdFound = FacilityList.some(
    (facility) => facility.id == FacilityId
  );
  const [currFacilityId, setCurrFacilityId] = useState(
    isFacilityIdFound ? FacilityId : ""
  );

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setFirstLoad(true);
    setLoading(true);

    setCurrProductGroupId(rowId);

    const newFacilityList = getFacilityListByGroup(rowId);
    // console.log("newFacilityList: ", newFacilityList);

    const fList = getSobapsWH(newFacilityList);
    // console.log("fList: ", fList);
    
    setFacilityList(fList);

    const isFacilityIdFound = fList.some(
      (facility) => facility.id == DefaultFacilityId
    );
    // console.log("isFacilityIdFound: ", isFacilityIdFound);
    // console.log("DefaultFacilityId DefaultFacilityId: ", DefaultFacilityId);
    setCurrFacilityId(isFacilityIdFound ? DefaultFacilityId : "");
  };

  function getSobapsWH(newFacilityList){
    const fList = newFacilityList.filter((facility) => {
        return (facility.FLevelId==1 || facility.FLevelId==2) 
        //&& facility.SOBAPSCode!= '' && facility.SOBAPSCode!= null ;
    });

    return fList;
  }
  const handleFacilityChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setFirstLoad(true);
    setLoading(true);

    setCurrFacilityId(rowId);
  };

  React.useEffect(() => {
    localStorage.setItem("FacilityId", currFacilityId);
  }, [currFacilityId]);

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(new Date(), 'yyyy-MM-dd')
  );

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  let params = {
    menukey: menukey,
    FacilityId: currFacilityId,
    action: "getDataList",
    StartDate: selectedStartDate,
    ItemGroupId: currProductGroupId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    RadioValue: radioValue,
  };

  const [isLoading, setLoading] = useState(false);

  const {
    error,
    isError,
    data,
    refetch: stockData,
  } = useQuery(
    [params],
    api.getstockstatus,
    {
      onSuccess: (data) => {
        if (firstLoad) {
          localStorage.setItem("StockData", JSON.stringify(data));
          setDataItems(data);
          setIsStockAvailable(data[0]?.IsStockAvailable || 0);
          setLoading(false);
          setFirstLoad(false);
        }
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    },
    {
      refetchOnWindowFocus: false,
      enabled: true,
    }
  );

  const setUpdatedDetailsGridDataHandler = (rows) => {
    const updateTableData = data.map((row) => {
      return row;
    });
    //setTableDataUpdate(updateTableData);
    //setDataItems(data);
  };

  // const { isLoading3, mutate: SaveAMC } = useMutation(api.UpdateAMC, {
  //   onSuccess: (data) => {
  //     if (data.status == 200) {
  //       stockData();

  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.data.message,
  //         msgtype: data.data.success,
  //       });
  //       //swal("Success!", "", "success");
  //     } else {
  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.data.message,
  //         msgtype: data.data.success,
  //       });
  //     }
  //   },
  // });

  // const handleSave = async (e) => {
  //   let FinalData = {
  //     action: "AMCUpdate",
  //     ManyJsonSave: tblRef.table.getData(),
  //     menukey: menukey,
  //     FacilityId: FacilityId,
  //     lan: lan,
  //     UserName: UserName,
  //   };
  //   SaveAMC(FinalData);
  // };

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let formatedDate = format(new Date(selectedStartDate), 'yyyy-MM-dd');
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName =
      FacilityList.find((Facility_List) => Facility_List.id == currFacilityId)
        ?.name ?? "";

    window.open(
      finalUrl +
        "?action=StockStatusSOBAPSExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&StartDate=" +
        formatedDate +
        "&FacilityId=" +
        currFacilityId +
        "&RadioValue=" +
        radioValue +
        "&FacilityName=" +
        currFacilityName +
        "&RoleItemGroupId=" +
        RoleItemGroupId +
        "&ItemGroupId=" +
        currProductGroupId +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    console.log(row._row);
    row._row.parent.rows.forEach((rowss, i) => {
      if (row._row.data.ItemNo == rowss.data.ItemNo) {
        localStorage.setItem("StockDataIndex", JSON.stringify(i));
        editUser(rowData);
        return;
      }
    });
  };

  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 75,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ProductCode",
      headerFilter: true,
      width: 130,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ProductName",
      headerFilter: true,
    },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["AMC"]),
    //   field: "AMC",
    //   width: 80,
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   validator: ["integer", "min:0"],
    //   cssClass:
    //     isStockAvailable === 0 && permissionType == 0
    //       ? "tabluator-column-editable"
    //       : "",
    //   editor:
    //     isStockAvailable === 0 && permissionType == 0 ? cellFocusEditor : "",
    //   //editor: cellFocusEditor,
    //   cellEdited: function (cell) {
    //     const curcellval = cell.getValue();
    //     const currow = cell.getRow();
    //     const rowdata = currow.getData();

    //     const pricecell = currow.getCell("MinimumQuantity");
    //     const MinimumQuantity = rowdata.MinimumQuantity_ * curcellval;
    //     pricecell.setValue(MinimumQuantity);

    //     const MaximumQuantity = currow.getCell("MaximumQuantity");
    //     MaximumQuantity.setValue(rowdata.MaximumQuantity_ * curcellval);

    //     let MOS = "";
    //     const Quantity = rowdata.Quantity;
    //     // console.log('Quantity: ', Quantity);
    //     // console.log('curcellval: ', curcellval);
    //     if (Quantity > 0 && curcellval == 0) {
    //       MOS = -1;
    //     } else if (curcellval > 0 && Quantity > 0) {
    //       MOS = (parseInt(Quantity) / parseInt(curcellval)).toFixed(1);
    //     }
    //     // console.log('MOS: ', MOS);

    //     const MOSCol = currow.getCell("MOS");
    //     MOSCol.setValue(MOS);
    //   },
    // },

    // {
    //   title: t(DispensingLanguage[lan][menukey]["Minimum Quantity"]),
    //   field: "MinimumQuantity",
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   width: 120,
    // },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["Maximum Quantity"]),
    //   field: "MaximumQuantity",
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   width: 120,
    // },
    {
      title: t(DispensingLanguage[lan][menukey]["Quantity"]),
      field: "Quantity",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 110,
    },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["MOS"]),
    //   field: "MOS",
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   width: 80,
    //   formatter: function (cell, formatterParams) {
    //     // MosTypelist
    //     //console.log('MosTypelist: ', MosTypelist);
    //     let value = cell.getValue();
    //     //console.log('value: ', value);
    //     let cellColor = "transparent";
        
    //     if (value == 0) {
    //       //
    //     } else if (value == "" || value == null) {
    //       return null;
    //     }

    //     value = parseFloat(value);

    //     // getNationalMOSRangeListByGroup(currProductGroupId)
    //     //console.log('getNationalMOSRangeListByGroup(currProductGroupId): ', getNationalMOSRangeListByGroup(currProductGroupId));
    //     // MosTypelist.forEach((row, i) => {
    //     getNationalMOSRangeListByGroup(currProductGroupId).forEach((row, i) => {
    //       // console.log("row: ", row);
    //       if (value > row.MinMos && value <= row.MaxMos) {
    //         cellColor = row.ColorCode;
    //       }
    //     });
    //     // console.log('cellColor: ', cellColor);

    //     cell.getElement().style.backgroundColor = cellColor;
    //     //return value;
    //     return value.toFixed(1);
    //   },
    // },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["Unit Price"]),
    //   field: "UnitPrice",
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   //width: 110,
    //   visible: false,
    // },
    // {
    //   title: t(DispensingLanguage[lan][menukey]["Line Total"]),
    //   field: "LineTotal",
    //   hozAlign: "right",
    //   headerHozAlign: "right",
    //   formatter: "money",
    //   //width: 130,
    //   visible: false,
    // },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      hozAlign: "center",
      headerHozAlign: "center",
      width: 80,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    // console.log(props.cell._cell.row);
    //const cellValue = props.cell._cell.value || 'Edit | Show';
    return (
      <>
        <ViewList
          onClick={() => {
            dataItems.forEach((row, i) => {
              if (rowData.ItemNo == row.ItemNo) {
                localStorage.setItem("StockDataIndex", JSON.stringify(i));
                editUser(rowData);
                return;
              }
            });
          }}
        />
      </>
    );
  }

  const handleStartDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedStartDate(date);
  };

  const handleChangePage = (data) => {
    setPageNumber(data);
    setFirstLoad(false);
  };
  const handleChangeRowPerPage = (data) => {
    setNumberRowPerPage(data);
  };

  const checkLogin = () => {
    let token = Constants.token;

    if (!token) {
      swal("Oops!", `token expired. Please login again`, "error");
      props.history.push("/login");
    }
  };
  const editUser = (data, dataItemss) => {
    let route = `stock-status-sobaps/edit/${data.ItemNo}`;
    props.history.push(route);
  };

  const changeRadio = (value) => {
    setFirstLoad(true);
    setLoading(true);
    setRadioValue(value);
  };

  React.useEffect(() => {
    setLoading(true);
    stockData();
  }, []);

  // React.useEffect(() => {
  //   let token = Constants.token;
  //   if (token) {
  //   }
  // }, []);

  // React.useEffect(() => {}, [
  //   pageNumber,
  //   numberRowPerPage,
  //   query,
  //   productGroupFilter,
  // ]);

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Stock Status"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      disabled={true}
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["Stock Date"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="ProductGroupList"
                    disableClearable
                    //disabled={userId == 1 ? false : true}
                    disabled={prodGroupCountUnderRole > 1 ? false : true}
                    options={ProductGroupList}
                    onChange={(event, newValue) =>
                      handleProductGroupChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      value={
                      (ProductGroupList.find(
                          (productGroupList) =>
                            productGroupList.id == currProductGroupId
                        ) ?? null)
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          DispensingLanguage[lan][menukey]["Product Group"]
                        }
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="FacilityList"
                    disableClearable
                    disabled={IsAllFacility == 1 ? false : true}
                    options={FacilityList}
                    value={
                      FacilityList.find(
                        (facility) => facility.id == currFacilityId
                      ) || null
                    }
                    onChange={(event, newValue) =>
                      handleFacilityChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={DispensingLanguage[lan][menukey]["Facility"]}
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3} sm={3}>
                {/* <FormControl component="fieldset" className="mt-3 ms-3">
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="row-radio-buttons-group"
                    defaultValue="SHOW_NONE_ZERO"
                  >
                    <FormControlLabel
                      value="SHOW_ALL"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW ALL"]}
                      onClick={() => changeRadio(0)}
                    />
                    <FormControlLabel
                      value="SHOW_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW ZERO"]}
                      onClick={() => changeRadio(1)}
                    />
                    <FormControlLabel
                      value="SHOW_NONE_ZERO"
                      control={<Radio />}
                      label={DispensingLanguage[lan][menukey]["SHOW NONE-ZERO"]}
                      onClick={() => changeRadio(2)}
                    />
                  </RadioGroup>
                </FormControl> */}
              </Grid>

              <Grid item xs={2} sm={2}>
                <div className="float-end sw_btn_control">
                  {/* <Button
                    className="me-2"
                    variant="contained"
                    color="info"
                    type="submit"
                    disabled={
                      isStockAvailable === 0 && permissionType == 0
                        ? false
                        : true
                    }
                    onClick={() => handleSave()}
                  >
                    {DispensingLanguage[lan][menukey]["Save AMC"]}
                  </Button> */}

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("print")}
                  >
                    <i className="fas fa-print"></i>
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        {/* start of legend */}
        {/* <Card className="sw_card sw_filter_card">
          <CardContent>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <div className="mylegend_area">
                  {getNationalMOSRangeListByGroup(currProductGroupId).map(
                    (item, index) => {
                      return (
                        <div key={index} className="my_legend">
                          <div
                            className="mylegend_color"
                            style={{ background: item.ColorCode }}
                          ></div>
                          <div className="mylegend_label">{item.name}</div>
                          <div className="mylegend_val">{item.MosLabel}</div>
                        </div>
                      );
                    }
                  )}
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card> */}
        {/* end of legend */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}

          <div className="uniqueName">
            <ReactTabulator
              onRef={(r) => { tblRef.table = r.current; }}
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="550px"
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
